import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKBlossom = () => (
  <ArticleWrapper articleId="gmk_blossom">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Blossom</h1>
        {/* Add your GMK Blossom article content here */}
        <p>This is a placeholder article for the GMK Blossom keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKBlossom;
